import { BASEURL } from "../../utilites";
import axios from "axios";
import { OPENAI_ACTION_TYPE } from "./Type";
import { global } from "../global/action";

const generateTaxPlan = (taxPlanData, abortController) => {
  return async (dispatch) => {
    dispatch({
      type: OPENAI_ACTION_TYPE.generateTaxPlan,
      payload: {
        message: "",
        status: "loading",
        data: {},
      },
    });

    try {
      const response = await axios.post(`${BASEURL}/api/openAI/generate-tax-plan`, { payload: taxPlanData }, { signal: abortController.signal});

      dispatch({
        type: OPENAI_ACTION_TYPE.generateTaxPlan,
        payload: {
          message: "success",
          status: true,
          data: response?.data?.data,
        },
      });
    } catch (error) {
      // console.log("ErrorFromBackend :" + JSON.stringify(error.response.data ,  null , 2));
      // console.log("EErrorName and errorcode :" + error.name + error.code);
      
      
      const isAborted = error.name === "CanceledError" || error.code === "ERR_CANCELED";
      if (!isAborted) {
        dispatch({
          type: OPENAI_ACTION_TYPE.generateTaxPlan,
          payload: {
            message: isAborted ? "Request cancelled" : handleOpenAIErrors("simple", error),
            status: false,
            data: {},
          },
        });
      }
    }
  };
};

const handleOpenAIErrors = (type, error) => {
  if (type === "simple") {
    // console.log("incomingError :" + JSON.stringify(error.response.data , null, 2));
    
    return error.code === "ERR_NETWORK" ? error?.message : error?.response?.data?.error?.message ? error?.response?.data?.error?.message : error?.response?.data?.message ? error?.response?.data?.message : error?.response?.data?.error || "An error occurred";
  }
};
const getTaxPlan = (key) => {
  return async (dispatch) => {
    // Dispatch loading state
    dispatch({
      type: OPENAI_ACTION_TYPE.getTaxPlan,
      payload: {
        message: "",
        status: "loading", 
        data: {},
      },
    });

    await axios
      .post(`${BASEURL}/api/openAI/generatetPresignedUrl`, key)
      .then((response) => {
        dispatch({
          type: OPENAI_ACTION_TYPE.getTaxPlan,
          payload: {
            message: "success",
            status: true, 
            data: response?.data?.data,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: OPENAI_ACTION_TYPE.getTaxPlan,
          payload: {
            message: handleOpenAIErrors("simple", error),
            status: false, // Error state
            data: {},
          },
        });
      });
  };
};

const deleteSavedTaxPlan = (id) => {
  return async (dispatch) => {
    dispatch({
      type: OPENAI_ACTION_TYPE.deleteSavedTaxPlan,
      payload: {
        message: "",
        status: "loading",
        data: {},
      },
    });

    try {
      const response = await axios.delete(`${BASEURL}/api/openAI/delete-saved-tax-plan/${id}`);

      dispatch({
        type: OPENAI_ACTION_TYPE.deleteSavedTaxPlan,
        payload: {
          message: "success",
          status: true,
          data: response?.data?.data,
        },
      });
    } catch (error) {
      dispatch({
        type: OPENAI_ACTION_TYPE.deleteSavedTaxPlan,
        payload: {
          message: handleOpenAIErrors("simple", error),
          status: false,
          data: {},
        },
      });
    }
  };
}

const getTaxPlanHtml = (key) => { 
  return async (dispatch) => {   

    await axios
      .post(`${BASEURL}/api/openAI/get-tax-plan-html`, key)
      .then((response) => {
        dispatch({
          type: OPENAI_ACTION_TYPE.getTaxPlanHtml,
          payload: {
            message: "success",
            status: true, // Success state
            data: response?.data?.data,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: OPENAI_ACTION_TYPE.getTaxPlanHtml,
          payload: {
            message: handleOpenAIErrors("simple", error),
            status: false, // Error state
            data: {},
          },
        });
      });
  };
};

const getTaxPlanStrategies = (taxPlanData, abortController) => {
  return async (dispatch) => {
    dispatch({
      type: OPENAI_ACTION_TYPE.getTaxPlanStrategies,
      payload: {
        message: "",
        status: "loading",
        data: {},
      },
    });

    try {
      const response = await axios.post(
        `${BASEURL}/api/openAI/get-tax-plan-strategies`, 
        taxPlanData, 
        { signal: abortController?.signal }
      );

      dispatch({
        type: OPENAI_ACTION_TYPE.getTaxPlanStrategies,
        payload: {
          message: "success",
          status: true,
          data: response?.data?.data,
        },
      });
    } catch (error) {
      const isAborted = error.name === "CanceledError" || error.code === "ERR_CANCELED";
      if (!isAborted) {
        dispatch({
          type: OPENAI_ACTION_TYPE.getTaxPlanStrategies,
          payload: {
            message: handleOpenAIErrors("simple", error),
            status: false,
            data: {},
          },
        });
      } else {
        // Reset state to idle when request is aborted
        dispatch({
          type: OPENAI_ACTION_TYPE.getTaxPlanStrategiesIdle,
        });
      }
    }
  };
};

const getTaxPlanJson = (taxPlanId) => {
  return async (dispatch) => {
    dispatch(global.Loader(true));
    dispatch({
      type: OPENAI_ACTION_TYPE.getTaxPlanJson,
      payload: {
        message: "",
        status: "loading",
        data: {},
      },
    });

    try {
      const response = await axios.post(`${BASEURL}/api/openAI/get-tax-plan-json`, {
        id: taxPlanId,
      });

      dispatch({
        type: OPENAI_ACTION_TYPE.getTaxPlanJson,
        payload: {
          message: "success",
          status: true,
          data: response?.data?.data,
        },
      });
      dispatch(global.Loader(false));
    } catch (error) {
      dispatch({
        type: OPENAI_ACTION_TYPE.getTaxPlanJson,
        payload: {
          message: handleOpenAIErrors("simple", error),
          status: false,
          data: {},
        },
      });
      dispatch(global.Loader(false));
    }
  };
};

export const openAI = {
  generateTaxPlan,
  getTaxPlan,
  getTaxPlanHtml,
  deleteSavedTaxPlan,
  getTaxPlanStrategies,
  getTaxPlanJson
};
